import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { QueryParamsModel } from '../../_base/crud';
import { environment } from '../../../../environments/environment';
import { currentUser } from '../../auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private companyId: any;
  private baseUrl = `${environment.ME_BASE}/`;

  constructor(private httpClient: HttpClient, private store: Store<AppState>) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  loadDevices(queryParams: QueryParamsModel): Observable<any> {
    const url = `${this.baseUrl}companies/${this.companyId}/devices`;
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    const sort = queryParams.sortField.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());

    // tslint:disable-next-line:max-line-length
    const params = new HttpParams({
      fromString:
        'page=' + pageIndex + '&size=' + pageSize + '&sort=' + sort + `,${queryParams.sortOrder}`,
    });

    return this.httpClient.get<any>(url, { params });
  }

  createDevice(device: any): Observable<any> {
    const url = `${this.baseUrl}companies/${this.companyId}/devices`;
    return this.httpClient.post<any>(url, device);
  }

  deleteDevices(device: any) {
    return this.httpClient.delete<any>(
      `${this.baseUrl}companies/${this.companyId}/devices/${device.id}`,
    );
  }

  searchDevices(term: string): Observable<any> {
    const params = new HttpParams({ fromString: `term=${term}` });
    return this.httpClient.get<any>(
      `${this.baseUrl}companies/${this.companyId}/devices/autocomplete`,
      { params },
    );
  }

  updateDevice(payload: any, id) {
    const url = `${this.baseUrl}companies/${this.companyId}/devices/${id}`;
    return this.httpClient.put<any>(url, payload);
  }
}
